(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const initRewards = (root) => {
    if (!root || root.dataset.loyaltyRewardsReady === 'true') return;
    root.dataset.loyaltyRewardsReady = 'true';

    const countdowns = root.querySelectorAll('[data-loyalty-countdown]');
    let countdownTimer = null;

    const updateCountdowns = () => {
      let hasValidCountdown = false;

      countdowns.forEach((countdown) => {
        const end = Date.parse(countdown.dataset.countdownEnd || '');
        if (!Number.isFinite(end)) return;

        hasValidCountdown = true;
        const remaining = Math.max(0, end - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        countdown.textContent = `${pad(days)}J : ${pad(hours)}H : ${pad(minutes)}M : ${pad(seconds)}S`;
      });

      if (hasValidCountdown && !countdownTimer) countdownTimer = window.setInterval(updateCountdowns, 1000);
    };

    updateCountdowns();

    const stopCountdown = () => {
      if (!countdownTimer) return;
      window.clearInterval(countdownTimer);
      countdownTimer = null;
    };

    const handleSectionUnload = (event) => {
      const sectionElement = event.target;
      if (!sectionElement?.contains?.(root)) return;
      stopCountdown();
      root.removeAttribute('data-loyalty-rewards-ready');
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    };
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    const modal = root.parentElement?.querySelector('[data-loyalty-notify-modal]');
    if (!modal) return;

    const sectionWrapper = root.closest('.shopify-section');
    const form = modal.querySelector('[data-notify-form]') || modal.querySelector('form');
    const closeButton = modal.querySelector('[data-loyalty-notify-close]');
    const methodButtons = modal.querySelectorAll('[data-notify-method]');
    const fields = modal.querySelectorAll('[data-notify-field]');
    const error = modal.querySelector('[data-notify-error]');
    const bodyInput = modal.querySelector('[data-notify-body]');
    let activeMethod = 'email';
    let lastTrigger = null;

    const setMethod = (method) => {
      activeMethod = method;
      methodButtons.forEach((button) => {
        const isActive = button.dataset.notifyMethod === method;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      fields.forEach((field) => {
        const isActive = field.dataset.notifyField === method;
        field.hidden = !isActive;
        const input = field.querySelector('input');
        if (input) input.required = isActive;
      });
      if (error) error.hidden = true;
    };

    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('loyalty-notify-open');
      sectionWrapper?.classList.remove('loyalty-notify-active');
      lastTrigger?.focus();
    };

    root.querySelectorAll('[data-loyalty-notify-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        lastTrigger = trigger;
        modal.hidden = false;
        document.documentElement.classList.add('loyalty-notify-open');
        sectionWrapper?.classList.add('loyalty-notify-active');
        setMethod(activeMethod);
        window.requestAnimationFrame(() => modal.querySelector('[data-notify-method].is-active')?.focus());
      });
    });

    methodButtons.forEach((button) => button.addEventListener('click', () => setMethod(button.dataset.notifyMethod)));
    closeButton?.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    form?.addEventListener('submit', (event) => {
      const activeInput = modal.querySelector(`[data-notify-field="${activeMethod}"] input`);
      if (!activeInput?.value.trim() || !activeInput.checkValidity()) {
        event.preventDefault();
        if (error) error.hidden = false;
        activeInput?.focus();
        return;
      }
      if (bodyInput) bodyInput.value = `Demande d’alerte fidélité — préférence : ${activeMethod}`;
    });

    setMethod(activeMethod);
  };

  document.querySelectorAll('.loyalty--rewards').forEach(initRewards);
  document.addEventListener('shopify:section:load', (event) => {
    initRewards(event.target.querySelector?.('.loyalty--rewards'));
  });
})();
